export default __webpack_public_path__ + "static/media/ceramx-cloud-farbe-a2.8ffcd14a.png";